import axios from 'axios'
import { LISTAR_FILTROS_USUARIO } from '../types'
import { URL } from '../../util/ambienteActions';

export default function listarFiltrosUsuario (idEmpresa) {
  const url = `${URL}/usuarios/empresa/${idEmpresa}/filtros`

  return dispatch => axios.get(url).then(
      response => dispatch({
        type: LISTAR_FILTROS_USUARIO,
        payload: response

      })
  );
}
